export default "__VITE_ASSET__lVsBa0iw__"